module.exports = __webpack_public_path__ + "img/zs4.90f89bfe.jpg";